<!-- WindowHeaderFooter.vue -->
<script setup lang="ts">
    import '../../css/choice.css';
    import {reactive, watch, onMounted,onBeforeUnmount} from 'vue'; 
    import ChoiceStateMessageSink from '../components/ChoiceStateMessageSink.vue';
 
    const formData = reactive <
    {
        display: {useHeader: boolean, useFooter: boolean}
        window: {headerHeight: number, footerHeight: number, windowPadding: number,workareaHeight: number, totalHeight: number},
    }>({      
        display: {useHeader: false, useFooter: false},
        window: {headerHeight: 1.5, footerHeight: 2.5, windowPadding: 0, workareaHeight: 8, totalHeight: 13}, 
    });

    const props = withDefaults(defineProps<{   
        headerHeight?: number,  // In rem units
        footerHeight?: number,  // In rem units
        paddingHeight?: number,
        workareaHeight?: number,
        currentPathOveride?: string 
    }>(),
    {
        headerHeight: 0,
        footerHeight: 0,
        paddingHeight: 0
    });

    onMounted(() => {
        resetWindowPadding(props.paddingHeight);
        resetWindowHeader(props.headerHeight);
        resetWindowFooter(props.footerHeight);

        if (props.workareaHeight) {
            resetWindowWorkArea(props.workareaHeight);
        }
        
        resetDisplayHeights();
        window.addEventListener('resize', () => {resetDisplayHeights();}); 
    });
    
    onBeforeUnmount(() =>{  
        window.removeEventListener("resize",resetDisplayHeights); 
    });

    watch(() => props.headerHeight, (newHeight, oldHeight) => { 
        if (newHeight !== oldHeight) { 
            resetWindowHeader(newHeight);
            resetDisplayHeights();
        }
    });

    watch(() => props.footerHeight, (newHeight, oldHeight) => { 
        if (newHeight !== oldHeight) { 
            resetWindowFooter(newHeight);
            resetDisplayHeights();
        }
    });

    if (props.workareaHeight) {
        watch(() => props.workareaHeight, (newHeight, oldHeight) => { 
            if (newHeight !== oldHeight) { 
                if (newHeight) {
                    resetWindowWorkArea(newHeight);
                }                
                resetDisplayHeights();
            }
        });
    }    

    watch(() => props.paddingHeight, (newHeight, oldHeight) => { 
        if (newHeight !== oldHeight) { 
            resetWindowPadding(newHeight);
            resetDisplayHeights();
        }
    });

    function resetWindowHeader(newHeight : number) : void {
        formData.display.useHeader = (newHeight > 0);
        formData.window.headerHeight = newHeight;
    }
    function resetWindowFooter(newHeight : number) : void {
        formData.display.useFooter = (newHeight > 0);
        formData.window.footerHeight = newHeight;
    }
    function resetWindowWorkArea(newHeight : number) : void {
        formData.window.workareaHeight = newHeight;
    }
    function resetWindowPadding(newHeight : number) : void {
        formData.window.windowPadding = newHeight;
    }
    function resetDisplayHeights(): void { 
        const windowHeight = (window.innerHeight / 16); 
        formData.window.totalHeight = windowHeight;
        formData.window.workareaHeight = props.workareaHeight ? props.workareaHeight : windowHeight - formData.window.headerHeight - formData.window.footerHeight - formData.window.windowPadding;
    }  
</script>

<style scoped>
    .window-header {
        border-bottom: 1px solid lightgray;
    }
    .window-footer {
        border-top: 1px solid lightgray;
    }
    @media print {
        .no-print {
            display: none;        
        }
    }
</style>
<template> 
    <div v-if="formData.display.useHeader" class="skinnyscroll window-header no-print" :style="{'overflow-y': 'scroll','overflow-x': 'hidden', 'height': (formData.window.headerHeight + 'rem')}">
        <slot name="WindowHeader"></slot>  
    </div>
    <div class="skinnyscroll pt-3" :style="{'overflow-y': 'scroll', 'overflow-x': 'hidden', 'height': (formData.window.workareaHeight + 'rem')}">
        <slot name="WindowBody"></slot>
    </div>  
    <div v-if="formData.display.useFooter" class="skinnyscroll window-footer pt-2 no-print" :style="{'overflow-y': 'scroll', 'overflow-x': 'hidden', 'height': (formData.window.footerHeight + 'rem')}">
       <slot name="WindowFooter"></slot>
    </div>
    <ChoiceStateMessageSink 
        :currentPathOveride="props.currentPathOveride"
    />
</template>